import { Locales } from 'src/lib/constants';
import { getBlogIndexProps } from 'src/lib/blog-page-data';
import BlogIndexPage from 'src/components/Blog/Pages/BlogIndexPage';

export const getStaticProps = ({ preview }) => {
  return getBlogIndexProps({ locale: Locales.EN_EU, preview });
};

export default BlogIndexPage;
